import {Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ViewChildren, QueryList} from '@angular/core';
import {Router, ActivatedRoute, NavigationStart, NavigationEnd, RoutesRecognized} from '@angular/router';
import {Location} from '@angular/common';

import * as uuid from 'uuid';

import {AuthService} from './services/auth.service';
import {FeedbackService} from './services/feedback.service';
import {LogService} from './services/log.service';
import {PerfService} from './services/perf.service';
import {TabService} from './services/tab.service';
import {UserService} from './services/user.service';

// import {ReviewerContentComponent} from './reviewer/content/content.component';
// import {ContactsComponent} from './contacts/contacts.component';

import {ItdToolbarComponent} from './components/itd-toolbar/itd-toolbar.component';


/* tslint:disable:no-unused-variable */
let events = {
	'5dde71766d5342f39e8a0abfaaeab3f4': {
		domain: 'ptfilmfest',
		imageBasePath: 'https://s3-us-west-2.amazonaws.com/cdn.ptffportal.org/porttownsend/2016/reviewer/image/',
		wabFestivalId: '1364',
		filmTypeList: [
			'feature,narrative,feature narrative',
			'feature,documentary,feature documentary',
			'short,narrative,short narrative',
			'short,documentary,short documentary'
		],
		teamTypeList: [
			'narrative',
			'documentary'
		],
		programDirectorTypeList: [
			'feature,short,narrative,documentary,animation,student'
		],
		defaultSumissionCredentials : {
			filmFreewayUsername: 'ReviewerService@ptfilmfest.com',
			filmFreewayPassword: 'Opinions@boutFilm5',
			withoutaboxUsername: 'ReviewerService@ptfilmfest.com',
			withoutaboxPassword: 'Opinions@boutFilm5'
		}
	},
	'b3b5117aba6249e49084a02d7a1c2c6e': {
		domain: 'sedonafilmfestival',
		imageBasePath: 'https://s3-us-west-2.amazonaws.com/cdn.ptffportal.org/sedonafilmfestival/2017/reviewer/image/',
		wabFestivalId: '1318',
		filmTypeList: [
			'short,short',
			'documentary,feature documentary',
			'narrative,feature narrative',
			'feature,feature narrative'
		],
		teamTypeList: [
			'short',
			'feature,documentary',
			'feature,narrative'
		],
		programDirectorTypeList: [
			'short',
			'feature,documentary',
			'feature,narrative'
		],
		defaultSumissionCredentials : {
			filmFreewayUsername: 'screeners@sedonafilmfestival.com',
			filmFreewayPassword: 'Vi3wF1lms',
			withoutaboxUsername: 'screeners@sedonafilmfestival.com',
			withoutaboxPassword: 'Vi3wF1lms'
		}
	}
};
/* tslint:enable:no-unused-variable */


@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
	constructor(
		private activatedRoute: ActivatedRoute,
		private location: Location,
		private router: Router,

		private authService: AuthService,
		private feedbackService: FeedbackService,
		public log: LogService,
		private perf: PerfService,
		private tabService: TabService,
		private userService: UserService
	) {
		// console.log('AppComponent constructor');
	}


	@ViewChild('sidenav') sidenav;

	@ViewChildren(ItdToolbarComponent) toolBars: QueryList<ItdToolbarComponent>;

	// @ViewChild(ContactsComponent) contactsComponent: ContactsComponent;
	// @ViewChild(ReviewerContentComponent) reviewerContentComponent: ReviewerContentComponent;

	// eventId = '';

	view = true;
	help = false;
	feedback = false;

	feedbackComments = '';

	userProfile = {
		showFeatureNarrative: true,
		showFeatureDocumentary: true,
		showShortNarrative: true,
		showShortDocumentary: true,
		showShort: true,
		showUnsent: true,
		showSent: true,
		showAccepted: true,
		showReviewing: true,
		showRejected: true,
		showSubmissionIdAndDate: true,
		sortField: 'title',
		sortDirection: 'ascending',
		tempFilteredFilmCount: 0,
		tempTotalFilmCount: 0,
		isContentTab: false,
		isLetterTab: false,
		isLineupTab: false,
		hideAll: false,
		showToolbar: true,
		module: 'reviewer',
		tab: '',
		showFilmCount: true,
		showFilterType: 'all',					// all, team, none
		showReviewerFilms: true,
		showExternalLineupFilms: true,
		showSortField: true,
		showSortDirection: true,
		showLineupVoteFilter: true,
		showLetterFilter: true,
		displayFeatureNarrative: true,
		displayFeatureDocumentary: true,
		displayShortNarrative: false,
		displayShortDocumentary: false,
		displayShort: true
	};

	onlyReviewerOrOnlyObserver = false;
	onlyReviewerOrOnlyObserverDocumentary = false;
	onlyReviewerOrOnlyObserverNarrative = false;

	showGotoTop = false;

	pinMenuBar = true;
	showTwoRowMenuBar = false;
	tabs: any = {};

	needProfileInitialized = true;

	// tabLinkz = [
	// 	{label: 'SITE', link: 'reviewer/result'},
	// 	{label: 'FESTIVAL', link: 'reviewer/contact'},
	// 	{label: 'PROGRAM', link: 'reviewer/team'},
	// 	{label: 'REVIEWER', link: 'reviewer/content'},
	// 	{label: 'PASSES', link: 'reviewer/availalbe'},
	// 	{label: 'VOLUNTEER', link: 'reviewer/reviewing'},
	// 	{label: 'SPONSOR', link: 'reviewer/reviewed'},
	// 	{label: 'DONATION', link: 'reviewer/all'},
	// 	{label: 'SETTINGS', link: 'profile'},
	// 	{label: 'SYSTEM', link: 'reviewer/dev'}
	// ];



	// tabs2 = {
	// 	firstIndex: 3,
	// 	firstTabs: [
	// 		{name: 'SITE'},
	// 		{name: 'FESTIVAL'},
	// 		{name: 'PROGRAM'},
	// 		{name: 'REVIEWER'},
	// 		// {name: 'PASSES', link: 'reviewer/availalbe'},
	// 		// {name: 'VOLUNTEER', link: 'reviewer/reviewing'},
	// 		// {name: 'SPONSOR', link: 'reviewer/reviewed'},
	// 		// {name: 'DONATION', link: 'reviewer/all'},
	// 		// {name: 'SETTINGS', link: 'profile'},
	// 		{name: 'SYSTEM'}
	// 	],
	// 	secondTabs: [
	// 		{
	// 			index: 0,
	// 			tabs: [
	// 				{name: 'HOME', link: 'site/home'},
	// 				{name: 'STORY', link: 'site/story'},
	// 				{name: 'FEATURES', link: 'site/features'},
	// 				{name: 'PRICING', link: 'site/pricing'},
	// 				{name: 'GET STARTED', link: 'site/getstarted'},
	// 				{name: 'CONTACT', link: 'site/contact'}
	// 			]
	// 		},
	// 		{
	// 			index: 0,
	// 			tabs: [
	// 				// {name: 'ROSE THEATER', link: 'festival/venues'},
	// 				{name: 'CONCIERGE', link: 'festival/concierge'},
	// 				{name: 'BALLOTS', link: 'festival/ballots'},
	// 				{name: 'NEXT UP', link: 'festival/nextup'},
	// 				{name: 'PROGRAM', link: 'festival/program'},
	// 				{name: 'FILMS', link: 'festival/films'},
	// 				{name: 'FAVORITES', link: 'festival/favorites'},
	// 				{name: 'TICKETS', link: 'festival/tickets'}
	// 			]
	// 		},
	// 		{
	// 			index: 0,
	// 			tabs: [
	// 				{name: 'LINEUP', link: 'program/lineup'},
	// 				{name: 'LETTER', link: 'program/letter'},
	// 				{name: 'BLOCK', link: 'program/block'},
	// 				{name: 'GRID', link: 'program/grid'},
	// 				{name: 'BALLOT', link: 'program/ballot'}
	// 			]
	// 		},
	// 		{
	// 			index: 0,
	// 			tabs: [
	// 				{name: 'RESULTS', link: 'reviewer/results'},
	// 				{name: 'TEAM', link: 'reviewer/team'},
	// 				{name: 'CONTENT', link: 'reviewer/content'},
	// 				{name: 'AVAILABLE', link: 'reviewer/available'},
	// 				{name: 'REVIEWING', link: 'reviewer/reviewing'},
	// 				{name: 'REVIEWED', link: 'reviewer/reviewed'},
	// 				{name: 'ALL', link: 'reviewer/all'},
	// 				{name: 'CONTACTS', link: 'common/contacts'},
	// 				// {name: 'SETTINGS', link: 'common/settings'},
	// 				{name: 'PROFILE', link: 'common/profile'},
	// 				{name: 'DEV', link: 'reviewer/dev'}
	// 			]
	// 		},
	// 		{
	// 			index: 0,
	// 			tabs: [
	// 				{name: 'ORGANIZATION', link: 'system/organization'},
	// 				{name: 'EVENT', link: 'system/event'},
	// 				{name: 'EMAIL', link: 'system/email'},
	// 				{name: 'PRECONTENT', link: 'system/precontent'}
	// 			]
	// 		}
	// 	]
	// };







	// async ngOnInit() {
	ngOnInit() {
		// console.log('AppComponent ngOnInit #1');

		// save to be used on unhandled exception
		window['log'] = this.log;

		// console.log('AppComponent ngOnInit #1.1');

		this.log.originalHref = window.location.href;
		// console.log('AppComponent, this.log.originalHref');
		// console.log(this.log.originalHref);

		// console.log('AppComponent ngOnInit #1.2');

		if (!localStorage) {
			this.log.error('No local storage support.');
		}
		if (!window.indexedDB) {
			this.log.error('No indexed db support.');
		}

		// console.log('AppComponent ngOnInit #1.3');

		try {
			if (localStorage) {
				// console.log('AppComponent ngOnInit #1.4');

				// check if there is a deviceId
				let visitDeviceId = localStorage.getItem('d');
				// console.log('AppComponent ngOnInit #1.5');

				if (visitDeviceId) {
					// console.log('AppComponent ngOnInit #1.6');
					// returning device, inc count
					this.log.visitDeviceId = visitDeviceId;

					let tempVisitCount = 1;
					let visitCountString = localStorage.getItem('c');
					try {
						tempVisitCount = parseInt(visitCountString, 10);
						tempVisitCount += 1;
					} catch (ex) {
						tempVisitCount = 1;
					}
					this.log.visitCount = tempVisitCount;
					localStorage.setItem('c', '' + this.log.visitCount);

					this.log.visitUserId = localStorage.getItem('u');
					if (!this.log.visitUserId && this.authService.userId) {
						this.log.visitUserId = this.authService.userId;
						localStorage.setItem('u', '' + this.log.visitUserId);
					}
				} else {
					// console.log('AppComponent ngOnInit #1.7');
					// new device
					this.log.visitDeviceId = uuid.v4().replace(/-/g, '');
					localStorage.setItem('d', this.log.visitDeviceId);

					this.log.visitCount = 1;
					localStorage.setItem('c', '' + this.log.visitCount);

					this.log.info('New device. visitDeviceId = ' + this.log.visitDeviceId);
				}
			}
		} catch (err) {
			console.log('AppComponent ngOnInit, Error writing to local storage');
			console.log(err);
		}

		// console.log('AppComponent ngOnInit #2');


		// !!! TODO - turn this into subscription
		this.pinMenuBar = this.tabService.pinMenuBar;
		this.showTwoRowMenuBar = this.tabService.showTwoRowMenuBar;
		this.tabs = this.tabService.navTabs;

		this.tabService.pinMenuBarSource.asObservable()
			.subscribe((pinMenuBarChecked) => {
				console.log('pinMenuBarChecked');
				console.log(pinMenuBarChecked);
				this.pinMenuBar = pinMenuBarChecked;
			});

		this.tabService.showTwoRowMenuBarSource.asObservable()
			.subscribe((showTwoRowMenuBarChecked) => {
				// console.log('showTwoRowMenuBarChecked');
				// console.log(showTwoRowMenuBarChecked);
				this.showTwoRowMenuBar = showTwoRowMenuBarChecked;
			});

		this.tabService.newTabsSource.asObservable()
			.subscribe((newTabs) => {
				// console.log('newTabs');
				// console.log(newTabs);
				this.tabs = newTabs;
			});

/*
		// ensure auth already read, so can make api call to get user info
		if (this.authService.readAuthFromLocalStorage()) {
			// new, now always read profile to get settings at startup, but only after auth
			// init twoRowMemuBar before updating tabs

			// tab service always reads the profile name from local storage
			// check to see if profile name does not exist in local storage
			// if not there, make call to get, store, then refresh tabs
			if (this.authService.organizationId && !this.userService.settings) {
				console.log('AppComponent before userService.getUserProfile()');
				let profile: any = await this.userService.getUserProfile();
				console.log('AppComponent after userService.getUserProfile()');
				if (profile) {
					if (profile && profile.profile) {
						let savedInfo: any = {
							firstName: profile.profile.firstName,
							lastWithoutaboxLogin: 0,
							lastFilmFreewayLogin: 0
						};

						if (localStorage) {
							let savedInfoString2 = JSON.stringify(savedInfo);
							localStorage.setItem('saved-info', savedInfoString2);
						}

						if (this.userService.settings && this.userService.settings.profile) {
							if (this.userService.settings.profile.twoRowMemuBar) {
								this.tabService.showTwoRowMenuBar = this.showTwoRowMenuBar = true;
							} else {
								this.tabService.showTwoRowMenuBar = this.showTwoRowMenuBar = false;
							}
						}
					}
				}
				// this.tabService.updateTabsByRoute(currentPath);
			}
		}
*/

		// console.log('AppComponent ngOnInit #3');


		this.router.events.subscribe( (ev) => {
			// console.log('>>>>> AppComponent router.events.subscribe');

			if (ev instanceof NavigationStart) {
				let currentPath1 = this.location.path();
				// console.log('>>>>> NavigationStart: ' + currentPath1);
				this.log.currentPath = ev.url;
				this.log.action(ev.url);
				return;
			}

			if (ev instanceof RoutesRecognized) {
				// console.log('>>>>> RoutesRecognized');
				return;
			}

			let end = (ev instanceof NavigationEnd);
			if (!end) {
				// console.log('>>>>> Unknown navigation event:');
				// console.log(ev);
				return;
			}
			let currentPath = this.location.path();
			// console.log('>>>>> NavigationEnd: ' + currentPath);
			console.log('NavigationEnd: ' + currentPath);
			// console.log(ev);


			try {
				// tab service always reads the profile name from local storage
				// check to see if profile name does not exist in local storage
				// if not there, make call to get, store, then refresh tabs
				if (this.authService.organizationId && window.localStorage) {
					if (!localStorage.getItem('saved-info')) {
						this.userService.getUserProfile()
							.then((profile: any) => {

								console.log('AppComponent, getUserProfile called');
								console.log('profile = ');
								console.log(profile);

								if (profile && profile.profile) {
									let savedInfo: any = {
										firstName: profile.profile.firstName,
										lastWithoutaboxLogin: 0,
										lastFilmFreewayLogin: 0
									};
									console.log('savedInfo = ' + savedInfo);
									console.log(savedInfo);

									let savedInfoString2 = JSON.stringify(savedInfo);
									localStorage.setItem('saved-info', savedInfoString2);

									this.tabService.setProfileName();
									this.tabService.updateTabsByRoute(currentPath);
									if (
										profile &&
										profile.profile &&
										profile.profile.settings &&
										profile.profile.settings.common &&
										profile.profile.settings.common.profile &&
										profile.profile.settings.common.profile.twoRowMemuBar
									) {

										console.log('profile.profile.settings.common.profile.twoRowMemuBar');
										console.log(profile.profile.settings.common.profile.twoRowMemuBar);

										this.tabService.showTwoRowMenuBarSource.next(true);
									}
									this.needProfileInitialized = false;
								}
							});
					} else if (this.needProfileInitialized) {
						this.userService.getUserProfile()
							.then((profile: any) => {

								// console.log('AppComponent, getUserProfile called for needProfileInitialized');
								// console.log('profile = ');
								// console.log(profile);

								if (
									profile &&
									profile.profile &&
									profile.profile.settings &&
									profile.profile.settings.common &&
									profile.profile.settings.common.profile &&
									profile.profile.settings.common.profile.twoRowMemuBar
								) {

									// console.log('profile.profile.settings.common.profile.twoRowMemuBar');
									// console.log(profile.profile.settings.common.profile.twoRowMemuBar);

									this.tabService.showTwoRowMenuBarSource.next(true);
								}
								this.needProfileInitialized = false;
							});
					}
				}
			} catch (err) {
				console.log('AppComponent router.events.subscribe, Error writing to local storage');
				console.log(err);
			}


			return this.authService.ensureAuth(currentPath)
				.then((newAuthPayload: any) => {
					// console.log('AppComponent, this.authService.ensureAuth, resolve, currentPath = ' + currentPath);
					// if (newAuthPayload) {
					// 	this.eventId = newAuthPayload.eventId;
					// 	this.updateVisibleTabsByAuth(newAuthPayload);
					// }

					// console.log('AppComponent ensureAuth, before tabService.updateTabsByRoute');
					this.tabService.updateTabsByRoute(currentPath);
					// console.log('AppComponent ensureAuth, after tabService.updateTabsByRoute');

					// update ink bar manually until Material Design fixes this
					// setTimeout(() => {
					// 	console.log('AppComponent setTimeout, updateInkBar');
					// 	this.toolBars.forEach((itdToolbarComponent: ItdToolbarComponent) => {
					// 		itdToolbarComponent.updateInkBar();
					// 	});
					// }, 10);

				})
				.catch((err: any) => {
					// TODO - handle errors?
					this.log.error(err);


					this.tabService.updateTabsByRoute(currentPath);

					// update ink bar manually until Material Design fixes this
					// setTimeout(() => {
					// 	// console.log('AppComponent setTimeout, updateInkBar');
					// 	this.toolBars.forEach((itdToolbarComponent: ItdToolbarComponent) => {
					// 		itdToolbarComponent.updateInkBar();
					// 	});
					// }, 10);

				});
		});

/*
		this.filmFilterService.filmCount
			.debounceTime(10)
			.subscribe((count) => {

			if (window.localStorage) {
				let savedInfo: any = {
					firstName: '',
					lastWithoutaboxLogin: 0,
					lastFilmFreewayLogin: 0
				};
				let savedInfoString = localStorage.getItem('saved-info');
				if (savedInfoString) {
					savedInfo = JSON.parse(savedInfoString);
				}

				if (savedInfo.firstName) {
					this.profileTabs.forEach((tab) => {
						if (tab.auth === 'app.profile') {
							tab.name = savedInfo.firstName;
						}
					});
				}
			}

			this.userProfile.tempFilteredFilmCount = count.selected;
			this.userProfile.tempTotalFilmCount = count.total;
			this.userProfile.isContentTab = (count.tab === 'content');
			this.userProfile.isLetterTab = (count.tab === 'letter');
			this.userProfile.isLineupTab = (count.tab === 'lineup');
			this.userProfile.hideAll = count.hideAll;
			if (typeof count.showToolbar === 'undefined') {
				this.userProfile.showToolbar = true;
			} else {
				this.userProfile.showToolbar = count.showToolbar;
			}
			this.userProfile.tab = count.tab;
			this.userProfile.showFilmCount = count.showFilmCount;
			this.userProfile.showSortField = count.showSortField;
			this.userProfile.showSortDirection = count.showSortDirection;
			this.userProfile.showLineupVoteFilter = count.showLineupVoteFilter;
			this.userProfile.showLetterFilter = count.showLetterFilter;

			if (count.module) {
				this.userProfile.module = count.module;
			} else {
				this.userProfile.module = 'reviewer';
			}

			if (count.savedFilter) {
				this.userProfile.showFeatureNarrative = count.savedFilter.showFeatureNarrative;
				this.userProfile.showFeatureDocumentary = count.savedFilter.showFeatureDocumentary;
				this.userProfile.showShortNarrative = count.savedFilter.showShortNarrative;
				this.userProfile.showShortDocumentary = count.savedFilter.showShortDocumentary;
				this.userProfile.showShort = count.savedFilter.showShort;

				this.userProfile.showUnsent = count.savedFilter.showUnsent;
				this.userProfile.showSent = count.savedFilter.showSent;

				this.userProfile.showAccepted = count.savedFilter.showAccepted;
				this.userProfile.showReviewing = count.savedFilter.showReviewing;
				this.userProfile.showRejected = count.savedFilter.showRejected;

				this.userProfile.showSubmissionIdAndDate = count.savedFilter.showSubmissionIdAndDate;
				this.userProfile.sortField = count.savedFilter.sortField;
				this.userProfile.sortDirection = count.savedFilter.sortDirection;
			}
			switch (count.showFilterType) {
			case 'all':
				if (this.eventId === '5dde71766d5342f39e8a0abfaaeab3f4') {
					this.userProfile.displayFeatureNarrative = true;
					this.userProfile.displayFeatureDocumentary = true;
					this.userProfile.displayShortNarrative = true;
					this.userProfile.displayShortDocumentary = true;
				}
				if (this.eventId === 'b3b5117aba6249e49084a02d7a1c2c6e') {
					this.userProfile.displayFeatureNarrative = true;
					this.userProfile.displayFeatureDocumentary = true;
					this.userProfile.displayShort = true;
				}
				break;

			case 'team':
				this.userProfile.displayFeatureNarrative = false;
				this.userProfile.displayFeatureDocumentary = false;
				this.userProfile.displayShortNarrative = false;
				this.userProfile.displayShortDocumentary = false;
				this.userProfile.displayShort = false;

				let teamString = this.authService.showRoleReviewerTeam;
				if (teamString) {
					// console.log('found teamString = ' + teamString);

					let teams = teamString.split(';');
					teams.forEach((team: any) => {
						if (team === 'all') {
							if (this.eventId === '5dde71766d5342f39e8a0abfaaeab3f4') {
								this.userProfile.displayFeatureNarrative = true;
								this.userProfile.displayFeatureDocumentary = true;
								this.userProfile.displayShortNarrative = true;
								this.userProfile.displayShortDocumentary = true;
							}
							if (this.eventId === 'b3b5117aba6249e49084a02d7a1c2c6e') {
								this.userProfile.displayFeatureNarrative = true;
								this.userProfile.displayFeatureDocumentary = true;
								this.userProfile.displayShort = true;
							}
						}
						if (team === 'both') {
							if (this.eventId === '5dde71766d5342f39e8a0abfaaeab3f4') {
								this.userProfile.displayFeatureNarrative = true;
								this.userProfile.displayFeatureDocumentary = true;
								this.userProfile.displayShortNarrative = true;
								this.userProfile.displayShortDocumentary = true;
							}
							if (this.eventId === 'b3b5117aba6249e49084a02d7a1c2c6e') {
								this.userProfile.displayFeatureNarrative = true;
								this.userProfile.displayFeatureDocumentary = true;
								this.userProfile.displayShort = true;
							}
						}
						if (team === 'documentary') {
							this.userProfile.displayFeatureDocumentary = true;
							this.userProfile.displayShortDocumentary = true;
						}
						if (team === 'narrative') {
							this.userProfile.displayFeatureNarrative = true;
							this.userProfile.displayShortNarrative = true;
						}
						if (team === 'feature,documentary') {
							this.userProfile.displayFeatureDocumentary = true;
						}
						if (team === 'feature,narrative') {
							this.userProfile.displayFeatureNarrative = true;
						}
						if (team === 'short') {
							this.userProfile.displayShort = true;
						}
					});
				} else {
					// console.log('teamString NOT found');

					if (this.eventId === '5dde71766d5342f39e8a0abfaaeab3f4') {
						this.userProfile.displayFeatureNarrative = true;
						this.userProfile.displayFeatureDocumentary = true;
						this.userProfile.displayShortNarrative = true;
						this.userProfile.displayShortDocumentary = true;
					}
					if (this.eventId === 'b3b5117aba6249e49084a02d7a1c2c6e') {
						this.userProfile.displayFeatureNarrative = true;
						this.userProfile.displayFeatureDocumentary = true;
						this.userProfile.displayShort = true;
					}
				}
				break;

			case 'none':
				this.userProfile.displayFeatureNarrative = false;
				this.userProfile.displayFeatureDocumentary = false;
				this.userProfile.displayShortNarrative = false;
				this.userProfile.displayShortDocumentary = false;
				this.userProfile.displayShort = false;
				break;
			}

			// console.log('userProfile');
			// console.log(this.userProfile);
		});

*/
	}


	ngAfterViewInit() {
		console.log('AppComponent ngAfterViewInit');
		this.perf.markAppStart();
	}


	ngOnDestroy() {
	}




/*
	onGotoTopOfPage() {
		window.scrollTo(0, 0);
	}


	onScroll(ev: any) {
		let bodyScrollTop = window.document.body.scrollTop || window.document.documentElement.scrollTop;
		let screenHeight = window.innerHeight;
		// console.log('bodyScrollTop = ' + bodyScrollTop);
		// console.log('screenHeight = ' + screenHeight);

		if (bodyScrollTop > 90) {
		// if (bodyScrollTop > 500) {
		// if (bodyScrollTop > screenHeight) {
			this.showGotoTop = true;
		} else {
			this.showGotoTop = false;
		}
	}
*/

	profileTabs = [{
		name: 'Contacts',
		route: '/contacts',
		isSelected: false,
		isEnabled: false,
		auth: 'app.contacts'
	}, {
		name: 'Companies',
		route: '/companies',
		isSelected: false,
		isEnabled: false,
		auth: 'app.companies'
	}, {
		name: 'Films',
		route: '/films',
		isSelected: false,
		isEnabled: false,
		auth: 'app.films'
	}, {
		name: 'Lineup',
		route: '/reviewer/program',
		isSelected: false,
		isEnabled: false,
		auth: 'app.reviewer.program'
	}, {
		name: 'Letter',
		route: '/reviewer/letter',
		isSelected: false,
		isEnabled: false,
		auth: 'app.reviewer.letter'
	}, {
		name: 'Block',
		route: '/reviewer/block',
		isSelected: false,
		isEnabled: false,
		auth: 'app.reviewer.block'
	}, {
		name: 'Grid',
		route: '/reviewer/grid',
		isSelected: false,
		isEnabled: false,
		auth: 'app.reviewer.grid'
	}, {
		name: 'Ballot',
		route: '/reviewer/ballot',
		isSelected: false,
		isEnabled: false,
		auth: 'app.reviewer.ballot'
	}, {
		name: 'Team',
		route: '/reviewer/team',
		isSelected: false,
		isEnabled: false,
		auth: 'app.reviewer.team'
	}, {
		name: 'Content',
		route: '/reviewer/content',
		isSelected: false,
		isEnabled: false,
		auth: 'app.reviewer.content'
	}, {
		name: 'Available',
		route: '/reviewer/available',
		isSelected: false,
		isEnabled: false,
		auth: 'app.reviewer.available'
	}, {
		name: 'Reviewing',
		route: '/reviewer/reviewing',
		isSelected: false,
		isEnabled: false,
		auth: 'app.reviewer.reviewing'
	}, {
		name: 'Reviewed',
		route: '/reviewer/reviewed',
		isSelected: false,
		isEnabled: false,
		auth: 'app.reviewer.reviewed'
	}, {
		name: 'All',
		route: '/reviewer/all',
		isSelected: false,
		isEnabled: false,
		auth: 'app.reviewer.all'
	}, {
		name: 'Settings',
		route: '/reviewer/settings',
		isSelected: false,
		isEnabled: false,
		auth: 'app.reviewer.settings'
	}, {
		name: 'Organization',
		route: '/system/organization',
		isSelected: false,
		isEnabled: false,
		auth: 'app.system.organization'
	}, {
		name: 'Event',
		route: '/system/event',
		isSelected: false,
		isEnabled: false,
		auth: 'app.system.event'
	}, {
		name: 'Email',
		route: '/system/email',
		isSelected: false,
		isEnabled: false,
		auth: 'app.system.email'
	}, {
		name: 'Profile',
		route: '/profile',
		isSelected: false,
		isEnabled: false,
		auth: 'app.profile'
	}, {
		name: 'Dev',
		route: '/reviewer/dev',
		isSelected: false,
		isEnabled: false,
		auth: 'app.reviewer.dev'
	}];


	public updateSelected(index: number) {
		if (index >= this.profileTabs.length) {
			return;
		}

		let authString = this.profileTabs[index].auth;
		authString = authString.slice(4);
		this.perf.markUserActionStart(authString + '.clicked');


		this.profileTabs.forEach( (profileTab) => {
			profileTab.isSelected = false;
		});
		this.profileTabs[index].isSelected = true;

		let route = this.profileTabs[index].route;
		this.router.navigate([route]);
	}


	// public updateSelectedTabByRoute(selectedRoute: string) {
	// 	// console.log('updateSelectedTabByRoute');
	// 	// console.log('selectedRoute');
	// 	// console.log(selectedRoute);

	// 	this.tabService.updateTabIndexesByRoute(this.tabs, selectedRoute);
	// }


/*
	public updateVisibleTabsByAuth(auth: any) {
		// console.log('auth.userAuthorizations');
		// console.log(auth.userAuthorizations);

		this.profileTabs.forEach( (profileTab) => {
			if (auth.userAuthorizations[profileTab.auth] && this.tabService.getVisibility(profileTab.auth)) {
				profileTab.isEnabled = true;
			} else {
				profileTab.isEnabled = false;
			}
		});
	}
*/

	// updateFilmList(ev: any) {
	// 	let filter = JSON.parse(JSON.stringify(this.userProfile));
	// 	this.filmFilterService.updateFilmFilter(filter);
	// }


	goToFaq() {
		// console.log('goToFaq clicked!!');
		this.view = true;
		this.help = false;
		this.feedback = false;
		// this.router.navigate(['profile'], { queryParams: { faq: 1 } });
		this.log.showFaq = true;
		this.router.navigate(['profile']);
	}


	goToFestival(tabName: string) {
		this.perf.markUserActionStart('festival.' + tabName + '.sidenav-clicked');

		console.log('goToFestival clicked!!');
		this.view = true;
		this.help = false;
		this.feedback = false;
		this.router.navigate(['festival/5dde71766d5342f39e8a0abfaaeab3f4/' + tabName]);
	}


	sendFeedback() {
		// console.log('sendFeedback clicked!!');
		// console.log('feedbackComments:');
		// console.log(this.feedbackComments);
		this.view = true;
		this.help = false;
		this.feedback = false;

		this.feedbackService.sendFeedback(this.feedbackComments)
		.then(() => {
			this.feedbackComments = '';
			this.log.info('Feedback saved to db!');
		})
		.catch((err: any) => {
			this.feedbackComments = '';
			// TODO - add toast
			// console.log('toast: server not available');
			this.log.error(err);
		});
	}



// !!! TODO - PUT THESE BACK !!!
	// exportLineup() {
	// 	this.sidenav.close();
	// 	this.filmFilterService.updateExportFilms();
	// }


	// exportAgile() {
	// 	this.sidenav.close();
	// 	this.filmFilterService.updateAgileExport();
	// }


	// addExternalFilm() {
	// 	this.sidenav.close();
	// 	this.perf.markUserActionStart('reviewer.program.add-external-film-clicked');

	// 	this.router.navigateByUrl('/reviewer/program/0');
	// 	// this.router.navigateByUrl('/reviewer/program/c857502877b44d5ca6691dbea25684b9');
	// }


	search() {
		console.log('search');
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/app.component.ts